import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle, withStateHandlers } from 'recompose'

import withMixpanel, { CREATE_GROUP_BUTTON_CLICK, CREATE_GROUP_SUCCESS, SCREEN_VIEW_MANAGE_TRAPS_GROUPS } from 'utils/mixpanel'
import { isEqual, getPaginationObject } from 'utils/misc'

import * as groupModule from 'modules/group'
import * as popoverModule from 'modules/popover'
import * as routeActions from 'actions/routeActions'

export default compose(
  withMixpanel,
  connect(
    (state) => {
      return {
        user: idx(state, _ => _.user),
        groups: idx(state, _ => _.groups.items),
        tableLoading: idx(state, _ => _.groups.loading),
        organisation: idx(state, _ => _.organisation.selected),
      }
    },
    (dispatch) => {
      const actions = {
        ...groupModule,
        ...routeActions,
        ...popoverModule,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  withStateHandlers(
    () => ({
      filters: {
        search: [{ key: 'name', value: null }],
        pagination: {
          offset: 0, limit: 8
        },
        loaded: true,
      }
    }),
    {
      onPageChange: state => (offset) => {
        return getPaginationObject(state, { offset }, false)
      },
      setPagination: state => ({ count }) => {
        return getPaginationObject(state, { count }, true)
      },
      setFilters: state => newFilters => ({
        ...state,
        filters: {
          ...state.filters,
          ...newFilters,
          loaded: false,
        }
      }),
    }
  ),
  withHandlers({
    onSearchChange: ({ setFilters }) => (value) => {
      setFilters({search: [{key: 'groupName', value}]})
    },
    onTableSortClick: ({ setFilters }) => (orderBy) => {
      setFilters({ orderBy: [orderBy] })
    },
    onCreateGroupClick: ({ 
      track, actions, organisation, filters, setPagination 
    }) => () => {
      track(CREATE_GROUP_BUTTON_CLICK)
      actions.showPopover(popoverModule.CREATE_GROUP, {
        organisation,
        filters,
        setPagination,
        onCreate: (values) => {
          track(CREATE_GROUP_SUCCESS)
          actions.createGroup(values, organisation, () => {
            actions.getGroups(organisation, filters, setPagination)
          })
        }
      })
    },
    onTableRowClick: props => (group) => {
      props.actions.selectManageGroup(group)
    },
  }),
  lifecycle({
    componentDidMount() {
      const {
        track, actions, organisation, filters, setPagination
      } = this.props

      track(SCREEN_VIEW_MANAGE_TRAPS_GROUPS)
      
      if (organisation) {
        actions.getGroups(organisation, filters, setPagination)
      }
    },
    componentDidUpdate(prevProps) {
      const {
        actions, organisation, filters, setPagination
      } = this.props

      if (!isEqual(filters, prevProps.filters) && !filters.loaded) {
        actions.getGroups(organisation, filters, setPagination)
      }
    }
  })
)



// WEBPACK FOOTER //
// ./src/containers/groups/ManageGroups/ManageGroups.enhancer.js